export const AppVersion = "v.1.0.2.4"
